import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from '../../../../../helpers/ui/CustomSelect';

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import { accessRole } from '../../../../../helpers/access_role'
import moment from 'moment';

// const peg_nip = JSON.parse(localStorage.getItem('userdata'))?.employee_nip ?? "";
// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
                { label: "Laki-laki", value: "L" },
                { label: "Perempuan", value: "P" }
            ],
            detail: [],
            selectedGender: "",
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: "",
            optionStatusApproval : [
                { label: "Disetujui", value: 1 },
                { label: "Ditolak", value: 2 }
            ],
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchApprove(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.skill_certification_uuid,
                employee_uuid: this.state.detail?.skill_certification_employee_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response_current = result.data.response.current
                    let response_history = result.data.response.history
                    if(result.data.status) {
                        this.setState({
                            detail: response_current,
                            history: response_history,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid'), history: 1 })

        /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
        try {
            let causer = queryParams.get('causer')

            if (causer != null){
                let arrCauser = atob(causer).split('|');
    
                let dataUser = {
                    employee_uuid: arrCauser[1],
                    employee_name : arrCauser[0],
                    employee_current_position_name : arrCauser[2],
                    employee_nip : arrCauser[3]
                }
                localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                //console.log(arrCauser);
            }
        } catch (error) {}
    }

    componentWillUnmount(){
        this.updateBloc.approveChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { result, detail } = this.state.detail
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="skillcertification"/> */}

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Approve Data Sertifikat Keahlian</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle> */}
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        {
                                            this.state.history ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    
                                                </label>
                                                <Col md="5">
                                                    <strong> Data Baru </strong>
                                                </Col>
                                                <Col md="4">
                                                    <strong className="text-danger"> Data Lama </strong>
                                                </Col>
                                            </Row>
                                        : '' }

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama Lembaga
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_institution_name !== "" ? this.state.detail.skill_certification_institution_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_institution_name !== "" ? this.state.history.skill_certification_institution_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama Sertifikat
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_name !== "" ? this.state.detail.skill_certification_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_name !== "" ? this.state.history.skill_certification_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tingkatan Sertifikat
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_level !== "" ? this.state.detail.skill_certification_level : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_level !== "" ? this.state.history.skill_certification_level : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor SK
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_sk_number !== "" ? this.state.detail.skill_certification_sk_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_sk_number !== "" ? this.state.history.skill_certification_sk_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal SK
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_sk_date !== "" ? this.dateParse(this.state.detail.skill_certification_sk_date) : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_sk_date !== "" ? this.dateParse(this.state.history.skill_certification_sk_date) : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal Expired
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_expire_date !== "" ? this.dateParse(this.state.detail.skill_certification_expire_date) : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_expire_date !== "" ? this.dateParse(this.state.history.skill_certification_expire_date) : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Registrasi
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.skill_certification_registration_number !== "" ? this.state.detail.skill_certification_registration_number : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.skill_certification_registration_number !== "" ? this.state.history.skill_certification_registration_number : '-'}</>
                                                    :
                                                        ""
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                File Pendukung
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail?.document != null ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.document?.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history?.document != null ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.history.document?.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <Select 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="5">
                                                <Link to="/kepegawaian/diklat/skillcertification.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/diklat/skillcertification.html'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);